
















































import Checkbox from '@front-app/components/inputs/Checkbox.vue';
import { defineComponent, PropType } from '@vue/composition-api';
import cloneDeep from 'clone-deep';
import { DigestMonthlyTiming, DigestTimingDay, MonthlyTimingKey } from '../../model';
import {
	SHORT_DAY_LABELS,
	WEEK_LABELS,
	MONTH_DAY_SELECT_LABEL_STRINGS,
	MONTH_DAY_DESELECT_LABEL_STRINGS,
} from '../../util/i18n';
import { orderedWeekDays, allMonthlyTimingKeys } from '../../util/scheduling';

export default defineComponent({
	components: { Checkbox },
	props: {
		value: {
			type: Object as PropType<DigestMonthlyTiming>,
			required: true,
		},
	},
	setup(props, ctx) {
		const emitUpdate = (week: MonthlyTimingKey, day: DigestTimingDay) => {
			const newTiming = cloneDeep(props.value);
			if (newTiming[week].has(day)) {
				newTiming[week].delete(day);
			} else {
				newTiming[week].add(day);
			}
			ctx.emit('input', newTiming);
		};
		return {
			emitUpdate,
			WEEK_LABELS,
			SHORT_DAY_LABELS,
			MONTH_DAY_SELECT_LABEL_STRINGS,
			MONTH_DAY_DESELECT_LABEL_STRINGS,
			allMonthlyTimingKeys,
			orderedWeekDays,
		};
	},
});
